<template>
  <div class="export_config_wrapper">
    <div class="mgx_action_btn" @click="exportConfig()">
      <div class="icon-wrapper">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 21V8M12 8L16 12M12 8L8 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M20 7V5C20 3.89543 19.1046 3 18 3H6C4.89543 3 4 3.89543 4 5V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
      <span>{{ $t('export_config') }}</span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { DeviceManager } from '@/service/device'
import { configSet } from '@/service/driver/config_set'
// 导出配置
const exportConfig = async () => {
  const index = configSet.currentConfig.value
  const res = await configSet.getExportConfigData(index)
  const name = configSet.configList.value[index].Name
  const b = JSON.stringify({ name: name, id: DeviceManager.instance.state.currentPid, content: res })
  const blob = new Blob([b], { type: 'application/octet-stream' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${name}.kbs`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
</script>

<style scoped lang="less"></style>
